var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIosApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37109 11.19V21.6341C4.37109 22.6644 5.19533 23.4999 6.23958 23.4999H19.2619C20.2783 23.4999 21.1304 22.6644 21.1304 21.6341V11.19C21.1304 10.1597 20.3062 9.32422 19.2619 9.32422H15.4982V10.7168H19.2619C19.5367 10.7168 19.7567 10.9398 19.7567 11.19V21.6341C19.7567 21.9126 19.5367 22.1074 19.2619 22.1074H6.23958C5.96483 22.1074 5.74482 21.8843 5.74482 21.6341V11.19C5.74482 10.9115 5.96483 10.7168 6.23958 10.7168H9.45382V9.32422H6.23958C5.19533 9.32422 4.37109 10.1597 4.37109 11.19Z",
    fill: "#667085",
    stroke: "#667085",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7402 5.46742L12.7178 2.49984M12.7178 2.49984L9.75 5.46742M12.7178 2.49984V15.0693",
    stroke: "#667085",
    strokeWidth: 1.74576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosApp);
export default __webpack_public_path__ + "static/media/iosApp.1d9804aa296c7236f125ff99ad192bdc.svg";
export { ForwardRef as ReactComponent };